export const queryToString = (query: string | (string | null)[]) => {
  return [query].flat()[0];
};
